import { useRecordContext } from 'react-admin';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';

const useController = () => {
  const record = useRecordContext();
  const { runRequest } = useRunRequest({ onCloseDialogKey: 'refresh_page' });

  const toggleActive = async () =>
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.FcraWorkers,
      params: {
        id: record.id,
        target: TurnTargetsEnum.UpdateActiveAddress,
      },
      useResponseDialog: true,
    });

  return {
    isActive: record.active,
    toggleActive,
  };
};

export default useController;
